// The starting point an operator sees when a revision has no bringup script yet.
//
// THE SCRIPT ITSELF IS NOT WRITTEN HERE. It is a verbatim copy of `system/bringup.sh`
// in the hiwonder_ros2 repo, imported raw, because that copy is linted in CI (sh -n +
// shellcheck) and ships inside the payload.
//
// This used to be a TypeScript template string, which meant the one script that runs as
// root on a virgin robot was the only code with no automated checking -- and both of the
// /dev/tty bugs found while writing it were found by rendering and running it, after the
// fact rather than before.
//
// To re-sync after the robot repo changes: scripts/sync-bringup-default.sh
import raw from './bringup.default.sh?raw';

export function defaultBringupScript(morphology: string, version: string): string {
  // A header, rather than templating the body. The script takes ROBOT_ID, ENROLL_TOKEN
  // and MORPHOLOGY as variables, so nothing inside it needs substituting -- and
  // interpolating into shell is how you end up serving something that no longer matches
  // what CI linted.
  return (
    `# Seeded from hiwonder_ros2 system/bringup.sh for ${morphology} revision ${version}.\n` +
    `# Edits here apply to this revision only; the canonical copy lives in that repo.\n` +
    raw
  );
}
